import { NgClass } from '@angular/common';
import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageEnums } from 'src/shared/models/enums';

@Component({
	selector: 'vl-slider-button',
	templateUrl: './slider-button.component.html',
	styleUrls: ['./slider-button.component.scss'],
	imports: [FormsModule, NgClass, TranslatePipe]
})
export class SliderButtonComponent implements OnInit, AfterViewInit {
	@ViewChild('range') range: ElementRef;
	@Output() slideChange: EventEmitter<any> = new EventEmitter<any>()
	value = 0;
	darkValue = 60;
	lang

	constructor(private storage: StorageService) {	
	}

	async ngOnInit() {
		this.lang = await this.storage.getItem(StorageEnums.LANG);
	}

	onChange(e) {
		if (e.type !== 'change') {
			return
		}
		let value = Number(e.target.value);
		if (value >= this.darkValue) {
			console.log('onChange', e);
			this.slideChange.emit(e.target.value);
			this.value = 100;
		} else {
			this.value = 0;
		}
	}

	public ngAfterViewInit(): void {
	}


}
